<template>
  <v-row no-gutters class="header-do-perfil" id="header-do-perfil">
    <v-col cols="3" style="max-width: 90px;">
      <v-responsive :aspect-ratio="1 / 1">
        <div
          class="foto-do-perfil"
          v-bind:style="{
            backgroundImage: `url(${profile.image || '/img/fav_icon2.png'})`
          }"
        ></div>
      </v-responsive>
    </v-col>

    <v-col cols="8" class="textos-do-perfil">
      <p class="nome-do-aluno text-truncate">{{ profile.name }}</p>
      <p v-if="role" class="dados-do-aluno text-truncate">
        Prof.
      </p>
      <p v-else class="dados-do-aluno text-truncate">
        {{ profile.credit_amount || 0 }} créditos para aulas particulares<br />
      </p>
      <v-rating v-if="profile.rating" background-color="red" color="white" :value="profile.rating" readonly></v-rating>
    </v-col>
  </v-row>
</template>

<script>

export default {
  props: {
    role: String,
    profile: Object
  },
  computed: {
  },
};
</script>

<style scoped>
.header-do-perfil {
  padding: 16px 20px;
}
.foto-do-perfil {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 2px solid #ffffff;
}
p.nome-do-aluno {
  color: #44ff99;
  text-transform: uppercase;
  font-weight: 900;
  margin-bottom: 6px;
  width: 100%;
}
p.dados-do-aluno {
  line-height: 2;
  color: #ffffff;
  font-size: 13px;
  margin: 0;
  font-weight: 400;
}
.textos-do-perfil {
  margin-left: 16px;
  width: 30px;
  height: 20px;
}
</style>
